export const cilVideo = ["24 24","<path d='M21.609 6.188l-4.734 1.841v-4.654h-16.125v17.25h16.125v-5.029l4.734 1.841h1.641v-11.25zM21.75 15.883l-6.375-2.479v5.722h-13.125v-14.25h13.125v5.347l6.375-2.479z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-video.js
// module id = null
// module chunks = 